define('home/models/common/BaseSettings',[
    'underscore',
    'backbone',

    'home/models/Session',
], function (
    _,
    Backbone,

    Session
) {
    'use strict';

    var BaseSettings = Backbone.Model.extend({
        shouldFetch: function () {
            return !this.fetched && !this.fetching;
        },

        ensureFetched: function () {
            if (!this.shouldFetch())
                return;

            var self = this;
            self.fetching = true;
            self.fetch({
                success: function () {
                    self.fetched = true;
                    self.fetching = false;
                },
                error: function () {
                    self.fetched = false;
                    self.fetching = false;
                },
            });
        },

        toFormData: function (attrs) {
            attrs = attrs || this.toJSON();
            return _.reduce(attrs, function (formData, value, key) {
                formData.append(key, _.isString(value) ? value.trim() : value);
                return formData;
            }, new window.FormData());
        },

        // set to true if form has a file upload input field
        useMultiPartForm: false,

        save: function (attrs, options) {
            attrs = attrs || this.toJSON();
            options = options || {};
            if (this.useMultiPartForm) {
                options.data = this.toFormData(attrs);
                options.contentType = false;
            }
            options.beforeSend = this.setCSRFHeader;
            return Backbone.Model.prototype.save.call(this, attrs, options);
        },

        setCSRFHeader: function (xhr, settings) {
            var csrftoken = Session.get().getCsrfToken();
            if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type))
                xhr.setRequestHeader('X-CSRFToken', csrftoken);
        },

        destroy: function (options) {
            options = options || {};
            options.beforeSend = this.setCSRFHeader;
            return Backbone.Model.prototype.destroy.call(this, options);
        },
    });

    return BaseSettings;
});


